import { Outlet } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileStickyNav from "@/components/MobileStickyNav";
import { useBusinessData } from "@/hooks/useBusinessData";
import { createContext, useContext } from "react";

const DataCtx = createContext(null);
export const useSite = () => useContext(DataCtx);

export default function Layout() {
  const data = useBusinessData();
  return (
    <DataCtx.Provider value={data}>
      <SmoothScroll>
        <ScrollToTop />
        <div className="bg-black text-white min-h-screen flex flex-col" data-testid="site-layout">
          <Nav config={data.config} />
          <main className="flex-1 pb-24 lg:pb-0">
            <Outlet />
          </main>
          <Footer config={data.config} />
          <MobileStickyNav config={data.config} />
        </div>
      </SmoothScroll>
    </DataCtx.Provider>
  );
}
